import { useToast, Box, Flex, Text, IconButton, Image } from '@chakra-ui/react'

import close from '@core/assets/images/close_toast.svg'

interface NotificationProps {
    message: string
    bg: string
    icon: string
}

const Notification = ({ message, bg, icon }: NotificationProps) => {
    const toast = useToast()

    return (
        <Box
            bg={bg}
            w={{ base: '320px', xl: '400px' }}
            boxShadow={'0px 8px 8px rgba(33, 186, 82, 0.16)'}
            borderRadius={'4px'}
            px={4}
            py={'14px'}
            position={'relative'}
            top={'80px'}
        >
            <Flex w={'full'} alignItems={'center'} justifyContent={'space-between'}>
                <Image src={icon} maxW={4} />
                <Text fontSize={'sm'} lineHeight={'20px'} color={'#fff'} ml={2}>
                    {message}
                </Text>
                <IconButton
                    maxW={5}
                    maxH={5}
                    display={'flex'}
                    justifyContent={'flex-end'}
                    variant={'unstyled'}
                    onClick={() => toast.closeAll()}
                    icon={<Image src={close} />}
                    aria-label={'close'}
                />
            </Flex>
        </Box>
    )
}

export default Notification
